import React, { useState } from "react";
import "./SapAbap.css";
import DownloadForm from "../DownloadForm/DownloadForm";

const SapPP = () => {
  const [showForm, setShowForm] = useState(false);

  const handleDownloadClick = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="sapfincon-wrapper">
      {/* Animated Background Circles */}
      <div className="background-animation">
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
      </div>

      {/* Header Section */}
      <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: "90px" }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1">Production Planning</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">SAP</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="sapfincon-flexbox">
        <div className="sapfincon-left">
          <div className="sapfincon-wrapper zoom-effect">
            <img
              src="/assets/img/sapfince.jpg"
              alt="SAP Banner"
              className="sapfincon-main-image"
            />
          </div>
        </div>
        <div className="sapfincon-right">
          <h2 className="sapfincon-title">Shape the Future of Manufacturing with BDM Technology’s SAP PP Course.</h2>
          <p className="sapfincon-description">
            SAP Production Planning (PP) is a core module that enables organizations to manage and optimize manufacturing operations, ensuring efficient production processes, material flow, and resource utilization in real-time.
          </p>
          <ul className="sapfincon-list">
            {[
              "Comprehensive Production Control – Plan, track, and optimize all production activities.",
              "Real-Time Material & Capacity Planning – Minimize delays and overproduction.",
              "Integration with SAP Modules – Works seamlessly with MM, SD, FICO, and QM.",
              "Supports All Manufacturing Types – Discrete, process, and repetitive manufacturing.",
              "Boosts Plant Efficiency & Profitability – Maximize throughput while reducing waste.",
              "Foundation for Digital Manufacturing – Supports smart factories and Industry 4.0 practices.",
            ].map((text, idx) => (
              <li className="sapfincon-list-item" key={idx}>
                <span className="sapfincon-icon">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998
                       26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997
                       26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206
                       0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                  </svg>
                </span>
                <span className="sapfincon-text">{text}</span>
              </li>
            ))}
          </ul>
          <p className="sapfincon-careers">Production Planner, SAP PP Consultant, Plant Operations Analyst</p>
        </div>
      </div>

      {/* Course Upgrade Section */}
      <div className="sapfincon-content-section">
        <div className="container">
          <div className="upgrade-section">
            <h2 className="section-title">
              <strong>Upgrade your planning skills with BDM Technology's Expert-Led SAP PP Course!</strong>
            </h2>
            <p className="section-description">
              SAP PP is the backbone of manufacturing in ERP systems, supporting efficient production planning, scheduling, and execution across industries.
            </p>
          </div>

          {/* Why Study */}
          <div className="why-study-section">
            <h3 className="subsection-title"><strong>Why Study SAP Production Planning (PP)?</strong></h3>
            <p className="subsection-description">
              SAP PP supports every stage of production – from planning and scheduling to execution and reporting – and integrates with other modules like MM, SD, and QM, making it essential for professionals in manufacturing and supply chain domains.
            </p>
          </div>

          {/* Benefits */}
          <div className="benefits-section">
            <h3 className="subsection-title"><strong>Benefits of Learning SAP PP</strong></h3>
            <ul className="benefits-list">
              <li><strong>Comprehensive Production Control</strong> – Plan, track, and optimize all production activities.</li>
              <li><strong>Real-Time Material & Capacity Planning</strong> – Minimize delays and overproduction.</li>
              <li><strong>Integration with SAP Modules</strong> – Works seamlessly with MM, SD, FICO, and QM.</li>
              <li><strong>Supports All Manufacturing Types</strong> – Discrete, process, and repetitive manufacturing.</li>
              <li><strong>Boosts Plant Efficiency & Profitability</strong> – Maximize throughput while reducing waste.</li>
              <li><strong>High Career Demand</strong> – Required across industries like automotive, pharma, electronics, and FMCG.</li>
              <li><strong>Foundation for Digital Manufacturing</strong> – Supports smart factories and Industry 4.0 practices.</li>
            </ul>
          </div>

          {/* Future Scope */}
          <div className="future-scope-section">
            <h3 className="subsection-title"><strong>Future Scope of SAP PP</strong></h3>
            <ul className="scope-list">
              <li><strong>Smart Manufacturing Trends</strong> – Rising adoption of digital production planning tools.</li>
              <li><strong>IoT & Machine Integration</strong> – Connectivity between ERP and factory floor systems.</li>
              <li><strong>Predictive Production Analytics</strong> – AI-driven forecasting and preventive adjustments.</li>
              <li><strong>Global ERP Deployments</strong> – SAP PP is used by global manufacturers to unify their processes.</li>
              <li><strong>Integrated Supply Chain Planning</strong> – PP works hand-in-hand with MRP, CRM, and SCM tools.</li>
              <li><strong>S/4HANA Compatibility & Innovations</strong> – Continuous updates for agility and competitiveness.</li>
              <li><strong>AI & Predictive Analytics</strong> – AI-driven insights to forecast project risks and performance.</li>
            </ul>
          </div>

          {/* Key Features Section */}
          <div className="key-features-section">
            <h3 className="subsection-title">
              <strong>Key Features of BDM Technology</strong>
            </h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>100% Job-Oriented Training</h4>
                <p>Curriculum tailored to industry requirements, ensuring you gain the skills employers are looking for.</p>
              </div>
              <div className="feature-item">
                <h4>Industry Expert Faculties</h4>
                <p>Learn from seasoned professionals with real-world experience.</p>
              </div>
              <div className="feature-item">
                <h4>Flexible Demo Class Available</h4>
                <p>Opportunity to attend a demo session and experience the training style before enrolling.</p>
              </div>
              <div className="feature-item">
                <h4>Completed 400+ Batches</h4>
                <p>Proven track record with hundreds of successful batches, demonstrating program reliability and effectiveness.</p>
              </div>
              <div className="feature-item">
                <h4>Certification Guidance</h4>
                <p>Support throughout your journey to help you earn relevant certifications that boost your career.</p>
              </div>
              <div className="feature-item">
                <h4>Live Practical Sessions</h4>
                <p>Hands-on, interactive sessions to reinforce learning and apply concepts in real-time.</p>
              </div>
              <div className="feature-item">
                <h4>Peaceful Environment</h4>
                <p>A conducive learning atmosphere that helps you focus and maximize your learning potential.</p>
              </div>
            </div>
          </div>

          {/* Who Should Attend */}
          <div className="who-attend-section">
            <h3 className="subsection-title"><strong>Who Should Enroll</strong></h3>
            <ul className="attend-list">
              <li>Mechanical, Production, and Industrial Engineers</li>
              <li>Manufacturing and Supply Chain Professionals</li>
              <li>ERP aspirants targeting roles in planning or operations</li>
              <li>Fresh graduates seeking ERP-based production roles</li>
            </ul>
          </div>

          {/* Hiring Companies Section */}
          <div className="hiring-companies-section">
            <h3 className="subsection-title">
              <strong>Hiring Companies</strong>
            </h3>
            <div className="companies-grid">
              {[
                { logo: "/assets/img/Cognizant.png" },
                { logo: "/assets/img/tcs.jpg" },
                { logo: "/assets/img/infoysis.jpg" },
                { logo: "/assets/img/ibm.png" },
                { logo: "/assets/img/hcl.png" },
                { logo: "/assets/img/Accenture.png" },
                { logo: "/assets/img/capgemini.png" },
                { logo: "/assets/img/Deloitte.png" },
                { logo: "/assets/img/nttdata.png" },
                { logo: "/assets/img/wipro.png" },
                { logo: "/assets/img/KaarTech.png" },
                { logo: "/assets/img/lt.png" },
                { logo: "/assets/img/Siemens.png" },
                { logo: "/assets/img/techmahindra.png" },
              ].map((company, index) => (
                <div className="company-card" key={index}>
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="company-logo"
                  />
                  <span className="company-name">{company.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Salary Overview Section */}
          <div className="salary-overview-section">
            <h3 className="subsection-title">
              <strong>Salary Overview</strong>
            </h3>
            <div className="salary-grid">
              <div className="salary-item">
                <h4>Entry-Level (0-2 Years)</h4>
                <p className="salary-amount">₹5 - ₹8 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Mid-Level (2-5 Years)</h4>
                <p className="salary-amount">₹8 - ₹13 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Senior-Level (5+ Years)</h4>
                <p className="salary-amount">₹13 - ₹20+ LPA</p>
              </div>
              <div className="salary-item">
                <h4>SAP PP Solution Architects & Manufacturing Heads</h4>
                <p className="salary-amount">₹22 - ₹30+ LPA</p>
              </div>
            </div>
          </div>

          <div className="download-section">
            <h3 className="download-heading">
              Want to know more? <br />
              <span>Please download the course PDF.</span>
            </h3>
            <button className="download-button" onClick={handleDownloadClick}>
              📄 Download Course PDF
            </button>
          </div>

          {showForm && (
            <DownloadForm
              onClose={handleCloseForm}
              courseName="SAP PP"
              pdfUrl="/uploads/pdfs/pp-course.pdf"
            />
          )}
        </div>
      </div>



      
    </div>
  );
};

export default SapPP;